module.exports = "<payment-methods-form></payment-methods-form>";